export const queueNames = {
  load: 'qs-load',
  snapshot: 'qs-snapshot',
  transform: 'qs-transform',
  post: 'qs-post',
  maintenance: 'qs-maintenance',
  exports: 'qs-export',
  alerts: 'qs-alerts',
  telegram: 'qs-telegram',
  lookup: 'qs-lookup',
} as const;

export type QueueName = (typeof queueNames)[keyof typeof queueNames];

export interface LoadJobData {
  source: string;
  forceFull?: boolean;
  requestedBy?: string;
}

export interface TransformJobData {
  reason: string;
}

export interface ExportJobData {
  exportId: string;
}

export interface SignerLookupJobData {
  kind: 'signers';
  requestId: string;
  counterpartyIds: string[];
}

export type LookupJobData = SignerLookupJobData;

export interface SignerInfo {
  counterpartyId: string;
  position: string | null;
  name: string | null;
}

export function lookupReplyChannel(requestId: string): string {
  return `qs:lookup:${requestId}`;
}

export const refreshAllJobName = 'refresh-all';

export const realtimeChannel = 'qs:events';

export const realtimeEventTypes = ['data', 'live', 'alerts', 'exports', 'layouts', 'telegram'] as const;
export type RealtimeEventType = (typeof realtimeEventTypes)[number];

export interface RealtimeEvent {
  type: RealtimeEventType;
  at: string;
  version?: number;
  build?: string;
  userId?: string;
  id?: string;
}
